import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Select,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";
import { useBaseData } from "../../../../common/useBaseData";
import { useCountriesByName } from "../../../../common/countries/countryNames";

interface FormValues {
  country: string;
}

interface Props {
  currentValue: string;
}

export const ChangeCountry = ({ currentValue }: Props) => {
  const { saveOrganization, isSaving } = useSaveOrganization();
  const baseData = useBaseData();
  const countryOptions = useCountriesByName(baseData.countries);
  const toast = useToast();
  const { t } = useTranslation();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      country: currentValue,
    },
  });

  if (!baseData) return <div>{t("Loading")}...</div>;

  const newValue = watch("country");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ country: { countryId: values.country } });
      toast({ title: t("Country has been updated!"), status: "success" });
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl id="country" mt="20px" isInvalid={errors.country != null}>
        <FormLabel>{t("Company location")}</FormLabel>
        <Select placeholder={t("Select a country for your company") ?? ""} {...register("country")}>
          {countryOptions.map(({ country: e, name }) => (
            <option key={e.id} value={e.id}>
              {name}
            </option>
          ))}
        </Select>
        <FormHelperText>{t("Please select the country your company is located in")}.</FormHelperText>
        <FormErrorMessage>{errors.country && errors.country.message}</FormErrorMessage>
      </FormControl>
      {currentValue.trim() !== newValue.trim() && (
        <Button
          mt="10px"
          leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
          variant={"solid"}
          colorScheme="teal"
          size={"sm"}
          isLoading={isSaving}
          type="submit"
        >
          {t("Save change")}
        </Button>
      )}
    </form>
  );
};
